import React from 'react';
import CollapsePanel, {
  CollapsePanelProps as CollapsePanelCopyProps
} from 'antd/lib/collapse';

export type CollapsePanelProps = CollapsePanelCopyProps;

const ProCollapsePanel: React.FC<CollapsePanelProps> = (props) => {
  const { children, ...resProps } = props;

  return <CollapsePanel {...resProps}>{children}</CollapsePanel>;
};

export default ProCollapsePanel;
